import React, { useContext, useEffect } from 'react';
import useWidgetPreview from '../../../hooks/useWidgetPreview';
import { isDemo, WidgetsContext } from '../../../GlobalContex';

export default function Preview() {
  const { activeWidget, dispatchActiveWidget, setActiveWidgetMeta, setRemoteWidget } = useContext(WidgetsContext);
  const { WidgetPreview, widgetMeta, remoteWidget } = useWidgetPreview(activeWidget);

  useEffect(() => {
    if (!widgetMeta.params) return;
    setActiveWidgetMeta(widgetMeta);
    if (isDemo) {
      dispatchActiveWidget((widget) => {
        return {
          ...widget,
          app: { name: widgetMeta.type },
          settings: {
            ...widget.settings,
            params: widgetMeta.params.reduce((params, { name, value }) => {
              return Object.assign(params, { [name]: value });
            }, {}),
            context: 'editor'
          }
        };
      });
    }
  }, [widgetMeta]);

  useEffect(() => {
    setRemoteWidget(remoteWidget);
  }, [remoteWidget]);

  return (
    <>
      <WidgetPreview overrideSettings={activeWidget.settings} />
    </>
  );
}
